import { merge } from 'lodash';

import { DayType } from '../type';
import { DayStyleConfig, defaultDayStyle } from '../type';
import { Active } from './Active';
import { Disable } from './Disable';
import { Normal } from './Normal';

type Props = {
  date: Date;
  day: number;
  dayType: DayType;
  onSetDate?: (date: Date) => void;
  dayStyleConfig?: Partial<DayStyleConfig>;
  disabled?: boolean;
};

export const Day = ({ date, day, dayType = DayType.NORMAL, onSetDate, dayStyleConfig }: Props) => {
  const mergedDayStyleConfig = merge(defaultDayStyle, dayStyleConfig);

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      onSetDate?.(date);
    }
  };

  switch (dayType) {
    case DayType.NONE:
      return <Disable dayStyleConfig={mergedDayStyleConfig} day={day} />;
    case DayType.ACTIVE:
      return <Active dayStyleConfig={mergedDayStyleConfig} day={day} />;
    case DayType.DISABLE:
      return <Disable dayStyleConfig={mergedDayStyleConfig} day={day} />;
    case DayType.NORMAL:
    default:
      return (
        <Normal
          onClick={() => onSetDate?.(date)}
          onKeyDown={handleKeyDown}
          dayStyleConfig={mergedDayStyleConfig}
          day={day}
        />
      );
  }
};
